export * from './ActorFunctionFactoryTermRegex';
export * from './TermFunctionRegex';
